import * as React from 'react';
import { connect } from 'react-redux';
import { StyleRulesCallback, withStyles } from '@material-ui/core/styles';
import HttpService from '../../core/services/HttpService';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core/'
import Typography from '@material-ui/core/Typography'
import * as moment from 'moment';
import BreadCrumb from '../../shared/components/BreadCrumb'
import RequestService from '../../core/services/SubscriptionRequestService'

const requestService = RequestService.Instance;
const httpService = HttpService.Instance;

const styles: StyleRulesCallback = (theme: any) => ({
  formControl: {
    minWidth: 200,
  },
});

interface IState {
  isLoading: boolean
  assetId: any
  assets: any
  assetName: any
  subscriptions: any
  subscriptionId: any
}

class Verifications extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    const assetId = this.props.match.params.assetid;
    const subscriptionId = this.props.match.params.subscriptionId;
    this.state = {
      isLoading: true,
      assetId,
      subscriptionId,
      assets: {},
      assetName: {},
      subscriptions: {}
    }
  }

  public async componentDidMount() {
    const data = await httpService.get(process.env.REACT_APP_API_URL + 'subscriptions/' + this.state.subscriptionId + '/history', { disableErrorMessageing: true });
    let subscriptions = {};
    if (data.ok) {
      subscriptions = await data.json()
    }
    const assetName = await requestService.getAsset(this.state.assetId)
    this.setState({ ...this.state, subscriptions, assetName, isLoading: false })
  }

  public drawtable() {
    const { subscriptions } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date </TableCell>
            <TableCell>Original Status</TableCell>
            <TableCell>New Status</TableCell>
            <TableCell>Preformed by</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!subscriptions.history && <TableRow><TableCell colSpan={4} >No History found</TableCell></TableRow>}
          {subscriptions.history && subscriptions.history.length !== 0 && subscriptions.history.map((request: any, index: any) => {
            return (
              <TableRow key={index}>
                <TableCell title={moment(new Date(request.updatedOn)).format('YYYY-MM-DD, h:mm a')}>{moment(new Date(request.updatedOn)).fromNow()}</TableCell>
                <TableCell component="th" scope="row">
                  {subscriptions.history[index + 1] ? subscriptions.history[index + 1].state.name : "NEW"}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request.state.name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {request.updatedByUser.name}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    )
  }

  public render() {
    return (
      <div>
        <Typography variant="title" gutterBottom={true}>
          {this.state.assetName.name + " | " + (this.state.subscriptions.history ? this.state.subscriptions.history[0].environment.name : "") + " environment | Manage Subscriptions"}
        </Typography>
        <Typography color="textSecondary" gutterBottom>
          <BreadCrumb
            value='Console'
            to='/'
          />
          <BreadCrumb
            value='Assets'
            to='/verifications'
          />
          <BreadCrumb
            value={this.state.assetName.name}
            to={'/asset-subscriptions' + '/' + (this.state.subscriptions.history ? this.state.subscriptions.history[0].environment.name : "Live") + '/' + this.state.assetId}
          />
          History
        </Typography>
        {!this.state.isLoading && this.drawtable()}
      </div>
    )
  }
}


function mapStateToProps(state: any) {
  return {
    subscriptions: state.subscriptionReducer,
    data: state,
    isLoading: state.isLoadingReducer,
    assets: state.assetReducer
  };
}



export default connect(
  mapStateToProps
)(withStyles(styles)(Verifications));


// WEBPACK FOOTER //
// ./src/modules/subscription/pages/VerificationsHistory.tsx